import { inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
export const LayoutBreakpoint = Device.TabletLarge;
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.grey.grey1};
  --fgColor: ${brand.black};

  background: var(--bgColor);
  color: var(--fgColor);
  padding: var(--sectionSpacing) 0;
`;
const Inner = styled.div ``;
const IntroContent = styled.div `
  ${baseGrid};
  width: 100%;
  margin-bottom: var(--introSpacing);
`;
const Title = styled.h2 `
  ${h3}
  margin-bottom: 16px;
  grid-column: 1 / span 12;
  grid-row: 1;

  @media ${from(LayoutBreakpoint)} {
    grid-column: 1 / span 6;
    margin-bottom: 0;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Content = styled.div `
  ${contentStyles};
  grid-column: 1 / span 12;
  grid-row: 2;
  margin: -8px 0 0;

  @media ${from(LayoutBreakpoint)} {
    grid-column: 7 / span 6;
    grid-row: 1;
    margin: 0;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const GridContainer = styled.div `
  @media ${from(LayoutBreakpoint)} {
    ${baseGrid};
  }

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const ItemList = styled.div `
  @media ${from(LayoutBreakpoint)} {
    background: ${brand.white};
    grid-column: 1 / span 4;
    margin-right: calc(var(--gutterWidth) * -1);
    padding-bottom: 70px;
  }
`;
const DetailList = styled.div `
  @media ${until(LayoutBreakpoint)} {
    display: none;
  }

  @media ${from(LayoutBreakpoint)} {
    display: grid;
    grid-column: 5 / span 8;
  }
`;
const MarketSectorsSectionStyles = {
    Container,
    Content,
    DetailList,
    GridContainer,
    Inner,
    IntroContent,
    ItemList,
    Title,
};
export default MarketSectorsSectionStyles;
